import { useEffect, useState } from 'react';
import { Button } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

import { ReactComponent as AlarmIcon } from "assets/blackAlarm.svg";

import styles from './EditFollowUpDateMenu.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (date: string) => Promise<void>; // Date in ISO format (YYYY-MM-DD)
  onClear: () => Promise<void>;
}

const EditFollowUpDateMenu = ({ isOpen, onSubmit, onClose, onClear }: Props) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleCustomDateChange = (val: string | null) => {
    setSelectedDate(val);
  };

  const handleSubmitDate = async () => {
    if (selectedDate) {
      try {
        setSubmitting(true);
        await onSubmit(selectedDate);
      } finally {
        setSubmitting(false);
      }
    }
  };

  const handleSubmitClear = async () => {
    try {
      setSubmitting(true);
      await onClear();
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedDate(null);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.menu}>
        <div className={styles.followUpMenu}>
          <div className={styles.followUpMenuHeader}>
            <AlarmIcon width={25} height={25} />
            <span>Set Follow-Up Date</span>
          </div>
          <div className={styles.datepickerWrapper}>
            <DatePicker
              value={selectedDate}
              onChange={handleCustomDateChange}
              hideOutsideDates
              firstDayOfWeek={0}
            />
          </div>
          <Button
            type="button"
            color="#EEEEEE"
            fullWidth
            onClick={onClose}
            classNames={{ root: styles.cancelButton }}
          >
            CANCEL
          </Button>
        </div>
        <Button
          type="button"
          color="#EEEEEE"
          onClick={handleSubmitClear}
          classNames={{ root: styles.cancelButton }}
          disabled={submitting}
          loading={submitting}
        >
          Reset
        </Button>
        <Button
          type="button"
          color="#EEEEEE"
          onClick={handleSubmitDate}
          classNames={{ root: styles.doneButton }}
          disabled={!selectedDate || submitting}
          loading={submitting}
        >
          Done
        </Button>
      </div>
    </>
  );
};

export default EditFollowUpDateMenu;
